const interactiveUrl = '/interactive';

export default interactiveUrl;
